import * as React from "react";
export default function Query() {
  return (
    <>
      Välj vilken filtrering som ska användas för objekten av den valda typen.
      Alla objekt som träffas av filtreringen kommer att få uppdateringen.
    </>
  );
}
